import { Component, OnDestroy } from '@angular/core';

import { ReplaySubject } from 'rxjs';

import { SharedLanguageService } from '@language';
import {
    ExtendedProfileField,
    FieldReadHelper,
    PartialRecord,
    ShComplexReadonlyFieldComponent,
    ShSearchRoutingService
} from '@stylehaven/components';
import { ApiFragment } from '../../../../record/entities/api-fragment.entity';
import { Metadata } from '../../../../record/entities/metadata.entity';
import { GetProfileFieldLabel } from '../../../helpers/get-profile-field-label.helper';

@Component({
    standalone: false,
    selector: 'digihaven-series-service-readonly-field',
    templateUrl: './series-service-readonly-field.component.html',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss']
})
export class SeriesServiceReadonlyFieldComponent extends ShComplexReadonlyFieldComponent implements OnDestroy {
    public label!: string;

    public apiFragment$: ReplaySubject<ApiFragment> = new ReplaySubject<ApiFragment>(1);

    constructor(
        protected fieldHelper: FieldReadHelper,
        protected shSearchRoutingService: ShSearchRoutingService,
        protected translateService: SharedLanguageService
    ) {
        super(fieldHelper, shSearchRoutingService);
    }

    init(profileField: ExtendedProfileField, record: PartialRecord): void {
        this.label = GetProfileFieldLabel(this.translateService, profileField);
        const apiFragment = new ApiFragment(record.metadata as any as Metadata);
        this.apiFragment$.next(apiFragment);
    }

    public ngOnDestroy(): void {
        this.apiFragment$.complete();
        super.ngOnDestroy();
    }
}
